/* eslint-disable react-hooks/exhaustive-deps */
import React, {  useState } from "react";
import {
  blockAllDrivers,
  activateAllDrivers,
  setEmergencyState,
} from "../api/EmergencyControlApi";
import "./css/EmergencyControl.css"; // custom CSS file
import AccessControl from "../components/AccessControl";

export default function EmergencyControl() {

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("Normal");

  const handleBlock = async () => {
    setLoading(true);
    const res = await blockAllDrivers();
    setMessage(res.message || res.error);
    setStatus("Emergency Active 🚨");
    setLoading(false);
  };

  const handleActivate = async () => {
    setLoading(true);
    const res = await activateAllDrivers();
    setMessage(res.message || res.error);
    setStatus("System Normal ✅");
    setLoading(false);
  };

  const handleToggle = async (state) => {
    setLoading(true);
    const res = await setEmergencyState(state);
    setMessage(res.message || res.error);
    setStatus(state === "active" ? "System Normal ✅" : "Emergency Active 🚨");
    setLoading(false);
  };



  return (
    <div className="emergency-card">
<AccessControl
        allowedRoles={["SUPERADMIN", "ADMIN","HR", "NSM", "RSM", "ASM", "TSO"]}
        redirectTo="/404"
      />
      <h2 className="emergency-title">🚨 Emergency Control</h2>
      <p className="emergency-subtitle">
        Admin can block or activate all drivers instantly.
      </p>

      <div className="status-indicator">{status}</div>

      <div className="button-group">
        <button
          onClick={handleBlock}
          disabled={loading}
          className="btn btn-danger"
        >
          {loading ? "Processing..." : "Block All Drivers"}
        </button>

        <button
          onClick={handleActivate}
          disabled={loading}
          className="btn btn-success"
        >
          {loading ? "Processing..." : "Activate All Drivers"}
        </button>
      </div>

      <div className="button-group">
        <button
          onClick={() => handleToggle("deactivated")}
          disabled={loading}
          className="btn btn-warning"
        >
          {loading ? "Processing..." : "Toggle Deactivate"}
        </button>

        <button
          onClick={() => handleToggle("active")}
          disabled={loading}
          className="btn btn-success"
        >
          {loading ? "Processing..." : "Toggle Activate"}
        </button>
      </div>

      {message && <div className="alert">{message}</div>}
    </div>
  );
}
